import { render, staticRenderFns } from "./qualifications.vue?vue&type=template&id=5726db6d&"
import script from "./qualifications.vue?vue&type=script&lang=js&"
export * from "./qualifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports